<template>
  <div class="container mt-5">
    <span class="resize-loading" v-if="loading">
      <span class="loader"></span>
    </span>
    <h2 class="mb-4">{{ $t("ELIXIO_CONNECT.MODULES") }}</h2>
    <modules-list
      :modules="modules"
      :organization="selectedOrganization"
      :refreshing-service-id="refreshingServiceId"
      @onSubmited="handleServiceSubmited"
    />
  </div>
</template>

<script>
import ModulesList from "./components/ModulesList.vue";
import _ from "lodash";
export default {
  name: "ElixioConnect",
  components: { ModulesList },

  props: ["organization"],

  data() {
    return {
      modules: [],
      query: null,
      selectedRows: [],
      sort: "-created_at",
      total: 0,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [20, 50, 100, 500],
      },
      loading: true,
      refreshServiceloading: true,
      refreshingServiceId: null,
      selectedOrganization: this.organization,
    };
  },

  computed: {},

  created() {},

  methods: {
    getListDebounced: _.debounce(function () {
      this.getAll();
    }, 300),

    handleServiceSubmited({ success, service }) {
      // Si succès j'aimerais réactualiser le service dans la liste
      if (success) {
        this.refreshService(service);
      }
      this.$emit("onSubmited", { success, service });
    },

    async refreshService(service) {
      console.log("refreshService", service);
      let index = this.modules.findIndex((m) => m.id === service.id);
      // Si l'id n'existe pas, on cherche par le type (slug) service.service_type
      if (index === -1 && service.slug) {
        index = this.modules.findIndex(
          (m) => m.slug === service.slug
        );
      }
      if (index !== -1) {
        try {
          this.refreshingServiceId = service.id;
          this.refreshServiceloading = true;
          // Re-fetch the service details from the store or API
          const organizationId = this.selectedOrganization.id;

          const response = await this.$store.dispatch(
            "elixioConnectModule/refreshService",
            { serviceId: service.id, organizationId }
          );
          this.$set(this.modules, index, response.data.service);
        } catch (error) {
          console.error("refreshService => ", error);
          this.$notify({
            type: "danger",
            message: this.$t("ELIXIO_CONNECT.SOMETHING_WENT_WRONG"),
          });
        } finally {
          this.refreshingServiceId = null;
          this.refreshServiceloading = false;
        }
      }
    },

    async getAll() {
      try {
        this.loading = true;
        const organizationId = this.selectedOrganization.id;

        const response = await this.$store.dispatch(
          "elixioConnectModule/getAllServices",
          organizationId
        );

        this.modules = response.data;
      } catch (error) {
        console.error("Listservice => ", error);
        this.$notify({
          type: "danger",
          message: this.$t("ELIXIO_CONNECT.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.loading = false;
      }
    },
    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getAll();
    },
  },

  mounted() {},
  watch: {
    organization: {
      handler: "getListDebounced",
      immediate: true,
    },
  },
};
</script>
<style>
.form-control-label {
  margin: 10px 0 5px 0;
}
</style>
